<template>
    <div class="statis">
      <div class="row">
        <div class="col-md-12">
          <div class="progress">
            <div class="progress-bar" role="progressbar" :style="{width:getEmployerPercent + '%'}" style="background:black" :aria-valuenow="getEmployerPercent" aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar" role="progressbar" :style="{width:getCandidatePercent + '%'}" style="background:#0BA25D" :aria-valuenow="getCandidatePercent" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
        <div class="col-md-6 text-left">
            <div class="candidate-count">{{ employerNo | toCurrency }}</div>
            <div class="text-title">Nhà tuyển dụng</div>
        </div>
        <div class="col-md-6 text-right">
            <div class="employer-count text-green">{{ candidateNo | toCurrency}}</div>
            <div class="text-title text-green">Người dùng</div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'UserStatistic',
  props: ['candidateNo', 'employerNo'],
  computed: {
    totalUser() {
      return this.candidateNo + this.employerNo;
    },
    getCandidatePercent() {
      return Math.round((this.candidateNo/this.totalUser * 100));
    },
    getEmployerPercent() {
      return Math.round((this.employerNo/this.totalUser) * 100);
    },
  }
}
</script>
<style scoped>
.statis{
  padding-bottom: 0.8em;
}
.text-title{
  font-size: 2.5em;
}
.progress{
  margin-top: 1em;
  height: 0.5em;
}
.candidate-count, .employer-count{

  font-size: 4em; 
  margin-top: 0.5em;
  font-weight: 500;
}
</style>




// WEBPACK FOOTER //
// src/components/UserStatistic.vue